type NodeMap<T extends Numberlish> = Record<T, Node<T>>;
type VisitedMap = Dictionary<boolean>;
type Entry<T extends Numberlish> = [T, T];

class Node<T extends Numberlish> {
  map: NodeMap<T>;
  value: T;

  constructor(value: T) {
    this.value = value;
    this.map = {} as NodeMap<T>;
  }

  connect = (node: Node<T>): void => {
    if (this.map[node.value]) return;

    this.map[node.value] = node;

    node.connect(this);
  };

  search = (visitedMap: VisitedMap = {}): VisitedMap => {
    visitedMap[this.value] = true;

    for (const nodeValue in this.map) {
      const node = this.map[nodeValue];

      !visitedMap[node.value] && node.search(visitedMap);
    }

    return visitedMap;
  };
}

const toGroupList = <T extends Numberlish = string>(entryList: Entry<T>[]) => {
  const nodeMap = {} as NodeMap<T>;

  entryList
    .map(entry => entry.toSorted((a, b) => (a > b ? 1 : a < b ? -1 : 0)))
    .toSorted((a, b) => (a[0] > b[0] ? 1 : a[0] < b[0] ? -1 : 0))
    .forEach(entry => {
      const [first, second] = entry.map(value => {
        if (!nodeMap[value]) nodeMap[value] = new Node(value);

        return nodeMap[value];
      });

      first.connect(second);
    });

  const search = () => {
    const globalVisitedMap: VisitedMap = {};
    const componentList: string[][] = [];

    for (const nodeValue in nodeMap) {
      const node = nodeMap[nodeValue];

      if (!globalVisitedMap[node.value as Numberlish]) {
        const componentVisitedMap = node.search({});

        Object.assign(globalVisitedMap, componentVisitedMap);

        const sortedComponent = Object.keys(componentVisitedMap).sort(
          (a, b) => Number(a) - Number(b),
        );

        componentList.push(sortedComponent);
      }
    }

    return componentList;
  };

  return search();
};

export default toGroupList;
